import { handleValid, Input, Message, Typography } from 'components'
import { TabMyOrganizationItem, TypographyTypes } from 'interfaces'
import get from 'lodash/get'
import React, { useEffect, useState } from 'react'
import { Controller, Path } from 'react-hook-form'
import ReactQuill from 'react-quill'
import { configGenaral } from 'utils'
import { PropsComponentsMyOrganization } from './interfaceSlide.type'

export const SlideCustomText: React.FC<PropsComponentsMyOrganization> = ({
	pos,
	errors,
	register,
	setValue,
	watch,
	isValid,
	setFieldError,
	name,
	control
}): JSX.Element => {
	const rules = {
		title: {
			required: { value: true, message: 'This field is required' }
		},
		description: {
			required: { value: true, message: 'This field is required' },
			maxLength: {
				value: configGenaral.maxDescriptionLength,
				message: `Maximum ${configGenaral.maxDescriptionLength} characters exceeded`
			},
			validate: (e: string) => {
				const isEmpty = e === '<p><br></p>' || e.trim() === ''
				if (isEmpty) {
					return 'This field is required'
				}
				return true
			}
		}
	}

	const watchTitle = watch(
		`${name}.${pos}.component_value.title` as Path<{
			tabs: TabMyOrganizationItem[]
		}>
	)

	const watchDescription = watch(
		`${name}.${pos}.component_value.description` as Path<{
			tabs: TabMyOrganizationItem[]
		}>
	)

	const [localDescription, setLocalDescription] = useState(
		(watchDescription as string) || ''
	)

	const nameType = `simple_text-${name}-${pos}`
	const sectionErrors = get(errors, `${name}.${pos}.component_value`, {})
	const { title: errorTitle, description: errorDescription } = sectionErrors
	const isFieldValid = !(errorTitle || errorDescription)

	useEffect(() => {
		setLocalDescription((watchDescription as string) || '')
	}, [watchDescription])

	useEffect(() => {
		handleValid(nameType, isFieldValid, setFieldError)
		return () => {
			const fields = ['title', 'description'].map(field =>
				watch(
					`${name}.${pos}.component_value.${field}` as Path<{
						tabs: TabMyOrganizationItem[]
					}>
				)
			)

			if (fields.some(value => !value)) {
				handleValid(nameType, false, setFieldError)
			}
		}
	}, [isValid, errorTitle, errorDescription])

	return (
		<div className="flex flex-col justify-between h-[95%] p-2">
			<div className="flex flex-col w-full">
				<Input
					name={`${name}.${pos}.component_value.title`}
					title="Title"
					register={register}
					rules={rules.title}
					error={errorTitle}
					borderFull
					limit
					cantLimit={configGenaral.maxTitleLength}
					watchValue={String(watchTitle)}
					setValueInput={setValue}
					placeholder="Add a title"
				/>
				<Controller
					control={control}
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					name={`${name}.${pos}.component_value.description` as any}
					rules={rules.description}
					render={({ field: { onChange } }) => {
						return (
							<div className="mt-4">
								<div className="mb-3">
									<Typography
										title="Description"
										type={TypographyTypes.span}
										fontLeading="12/12"
									/>
								</div>
								<ReactQuill
									theme="snow"
									value={localDescription}
									onChange={(textCustom: string) => {
										const valueReplace = textCustom.replace(
											/color:\s?[^;]+;/gi,
											''
										)
										setLocalDescription(valueReplace)
										onChange(valueReplace)
									}}
									onBlur={() => {
										onChange(localDescription)
									}}
								/>
								{errorDescription && (
									<Message text={errorDescription.message} type="error" />
								)}
							</div>
						)
					}}
				/>
			</div>
		</div>
	)
}
